import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { router } from './router';

import { RequireAuth } from '@/auth/RequireAuth';
import { SessionProvider } from '@/auth/SessionProvider';

export function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 60_000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  // Ensure <html> has the .dark class — v1 is dark-only.
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RequireAuth>
          <RouterProvider router={router} />
        </RequireAuth>
      </SessionProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'var(--color-ugin-surface-elevated)',
            color: 'var(--color-ugin-text)',
            border: '1px solid var(--color-ugin-border)',
          },
        }}
      />
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
